import React, { useState } from 'react';
import styled from 'styled-components';
import { useAuth } from '../contexts/AuthContext';
import { colors } from '../styles';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../contexts/ToastContext';
import Input from './inputs/StyledInput';

const Register = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    displayName: '',
    username: ''
  });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validaciones
    if (!formData.email || !formData.password || !formData.displayName || !formData.username) {
      return toast.showToast('Todos los campos son obligatorios', 'error');
    }

    if (formData.password !== formData.confirmPassword) {
      return toast.showToast('Las contraseñas no coinciden', 'error');
    }

    if (formData.password.length < 6) {
      return toast.showToast('La contraseña debe tener al menos 6 caracteres', 'error');
    }

    setLoading(true);
    try {
      await register(formData);
      toast.showToast('Registro exitoso', 'success');
      navigate('/profile');
    } catch (err) {
      console.error(err);
      let errorMessage = 'Error al registrar usuario';
      if (err.code === 'auth/email-already-in-use') {
        errorMessage = 'El email ya está registrado';
      } else if (err.code === 'auth/invalid-email') {
        errorMessage = 'Email inválido';
      }
      toast.showToast(errorMessage, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <RegisterCard>
        <Title>Crear Cuenta</Title>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Input
              type="text"
              placeholder="Nombre completo"
              value={formData.displayName}
              onChange={(e) => setFormData({...formData, displayName: e.target.value})}
              icon={<UserOutlined />}
              required
            />
          </FormGroup>
          <FormGroup>
            <Input
              type="text"
              placeholder="Nombre de usuario"
              value={formData.username}
              onChange={(e) => setFormData({...formData, username: e.target.value})}
              icon="@"
              required
            />
          </FormGroup>
          <FormGroup>
            <Input
              type="email"
              placeholder="Email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              icon={<MailOutlined />}
              required
            />
          </FormGroup>
          <FormGroup>
            <Input
              type="password"
              placeholder="Contraseña"
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
              icon={<LockOutlined />}
              required
            />
          </FormGroup>
          <FormGroup>
            <Input
              type="password"
              placeholder="Confirmar contraseña"
              value={formData.confirmPassword}
              onChange={(e) => setFormData({...formData, confirmPassword: e.target.value})}
              icon={<LockOutlined />}
              required
            />
          </FormGroup>
          <RegisterButton 
            type="submit" 
            disabled={loading || !formData.email || !formData.password || !formData.displayName || !formData.username}
          >
            {loading ? 'Registrando...' : 'Registrarse'}
          </RegisterButton>
        </Form>
        <LoginLink onClick={() => navigate('/login')}>
          ¿Ya tienes cuenta? Inicia sesión
        </LoginLink>
      </RegisterCard>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 2rem;
  background-color: ${colors.primary};
`;

const RegisterCard = styled.div`
  background: ${colors.white};
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 12px ${colors.shadow};
  width: 100%;
  max-width: 400px;
`;

const Title = styled.h2`
  font-family: 'Caveat', cursive;
  color: ${colors.text};
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 2rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const RegisterButton = styled.button`
  height: auto;
  padding: 0.8rem;
  font-size: 1.1rem;
  font-family: 'Indie Flower', cursive;
  background-color: ${colors.secondary};
  border: none;
  color: ${colors.white};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1rem;

  &:hover:not(:disabled) {
    background-color: ${colors.accent};
    transform: translateY(-2px);
  }

  &:disabled {
    background-color: ${colors.text}80;
    cursor: not-allowed;
  }
`;

const LoginLink = styled.button`
  background: none;
  border: none;
  color: ${colors.secondary};
  font-family: 'Indie Flower', cursive;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 1rem;
  padding: 0.5rem;
  width: 100%;
  transition: all 0.3s ease;

  &:hover {
    color: ${colors.accent};
    text-decoration: underline;
  }
`;

export default Register; 